import {
  FilterItem,
  UrlFilters,
} from '@elementary/common-ui/hooks/useUrlFilters';
import { colors } from '@elementary/common-ui/style/theme';
import {
  TEST_RESULTS_TABLE_FILTERS,
  TREE_NODE,
  TREE_TYPE,
  TREE_VIEW_BY,
} from '@elementary/common-ui/constants/urlParams';
import { ThresholdLevel } from '../types';

export const getValueColor = (thresholdLevel: ThresholdLevel) =>
  !thresholdLevel || thresholdLevel === null
    ? colors.gray18
    : thresholdLevel === 'low'
    ? colors.red100
    : thresholdLevel === 'medium'
    ? colors.orange100
    : colors.green100;

export const getValueColorByNumber = (value: number) =>
  value === 0
    ? colors.gray18
    : value >= 66.66
    ? colors.green100
    : value >= 33
    ? colors.orange100
    : colors.red100;

const setTreeSearchParams = (
  currentParams: URLSearchParams,
  newParams: URLSearchParams,
) => {
  [TREE_NODE, TREE_TYPE, TREE_VIEW_BY].forEach((param) => {
    if (currentParams.get(param)) {
      newParams.set(param, currentParams.get(param)!);
    }
  });
};

export const getTestResultsLink = (
  currentParams: URLSearchParams,
  dataHealthFilters?: UrlFilters,
  columnKey?: string,
) => {
  const testResultsFilters: UrlFilters = [];
  const newParams = new URLSearchParams();

  if (columnKey) {
    testResultsFilters?.push({
      property: 'qualityDimension',
      operator: 'equals',
      value: [columnKey],
    });
  }

  if (dataHealthFilters) {
    const dataHealthToTestResultsFilters: FilterItem[] = dataHealthFilters.map(
      (filter) => {
        if (filter.property === 'owner') {
          return {
            ...filter,
            property: 'assetOwners',
            value: filter.value.map((owner) =>
              owner === 'No owners' ? '' : owner,
            ),
          };
        }

        if (filter.property === 'tag') {
          return {
            ...filter,
            property: 'assetTags',
            value: filter.value.map((tag) => (tag === 'No tags' ? '' : tag)),
          };
        }

        if (filter.property === 'name') {
          return {
            ...filter,
            property: 'assetName',
            value: filter.value.map((name) => (name === 'No name' ? '' : name)),
          };
        }

        if (filter.property === 'is_critical') {
          return {
            ...filter,
            property: 'criticalAsset',
            value: filter.value.map((val) =>
              val === 'true' ? 'true' : 'false',
            ),
          };
        }

        if (filter.property === 'subscriber') {
          return {
            ...filter,
            property: 'assetSubscribers',
            value: filter.value.map((sub) =>
              sub === 'No subscribers' ? '' : sub,
            ),
          };
        }

        if (filter.property === 'database_name') {
          return {
            ...filter,
            property: 'databaseName',
          };
        }

        if (filter.property === 'schema_name') {
          return {
            ...filter,
            property: 'schemaName',
          };
        }

        if (filter.property === 'test_tag') {
          return {
            ...filter,
            property: 'testTags',
            value: filter.value.map((tag) => (tag === 'No tags' ? '' : tag)),
          };
        }

        if (filter.property === 'test_owner') {
          return {
            ...filter,
            property: 'testOwners',
            value: filter.value.map((owner) =>
              owner === 'No owners' ? '' : owner,
            ),
          };
        }

        // Add a fallback return to satisfy TypeScript
        return filter;
      },
    );

    testResultsFilters.push(...dataHealthToTestResultsFilters);
  }

  newParams.set(TEST_RESULTS_TABLE_FILTERS, JSON.stringify(testResultsFilters));
  setTreeSearchParams(currentParams, newParams);

  return `/report/test-results?${newParams.toString()}`;
};
